import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export function GuaranteeSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-98">
      <div className="max-w-5xl mx-auto" data-id="element-99">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative overflow-hidden" data-id="element-100">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-30" data-id="element-101"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-100 rounded-full blur-3xl opacity-30" data-id="element-102"></div>

          <div className="relative flex flex-col md:flex-row gap-8 items-center" data-id="element-103">
            {/* Seal */}
            <div className="md:w-1/3 flex-shrink-0" data-id="element-104">
              <div className="relative w-48 h-48 mx-auto" data-id="element-105">
                {/* Animated dotted border */}
                <div className="absolute inset-0 border-4 border-dashed border-blue-600 rounded-full animate-spin-slow" style={{
                animationDuration: '20s'
              }} data-id="element-106"></div>
                {/* Inner circle */}
                <div className="absolute inset-4 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex flex-col items-center justify-center text-white" data-id="element-107">
                  <ShieldCheckIcon className="w-16 h-16 mb-2" data-id="element-108" />
                  <div className="text-2xl font-bold" data-id="element-109">45</div>
                  <div className="text-sm" data-id="element-110">GIORNI</div>
                  <div className="text-xs font-bold mt-1" data-id="element-111">GARANZIA</div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="md:w-2/3" data-id="element-112">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-113">
                Garanzia di Soddisfazione 100%
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-114">
                Prova il Mega-Pack per 45 giorni senza alcun rischio. Se per
                qualsiasi motivo non sei completamente soddisfatto, ti
                rimborsiamo il 100% del tuo investimento.
              </p>
              <div className="space-y-3 mb-6" data-id="element-115">
                <div className="flex items-center gap-3" data-id="element-116">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-117" />
                  <span className="text-gray-700" data-id="element-118">Nessun rischio per te</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-119">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-120" />
                  <span className="text-gray-700" data-id="element-121">
                    Rimborso completo del 100%
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-122">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-123" />
                  <span className="text-gray-700" data-id="element-124">Senza fare domande</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-125">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-126" />
                  <span className="text-gray-700" data-id="element-127">
                    Procedura semplice via email
                  </span>
                </div>
              </div>
              <button onClick={scrollToOffer} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300" data-id="element-128">
                Prova senza rischi
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}